export default "__VITE_ASSET__DUy9dbUe__"